var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "bright-fill",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D0D7DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M20 0C24.2236 5.03657e-08 28.3388 1.3371 31.7557 3.81966C35.1727 6.30222 37.716 9.80279 39.0211 13.8197C40.3263 17.8365 40.3263 22.1635 39.0211 26.1803C37.716 30.1972 35.1727 33.6978 31.7557 36.1803L20 20V0Z",
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.c2b0eac07f1e56ba8450cd9c75c1419c.svg";
export { ForwardRef as ReactComponent };